import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "module-other-document",
  languages: [
    "fi",
    "sv",
  ],
  title: "label.moduleOtherDocument",
  description: "description.moduleOtherDocument",
  configuration: merge({}, defaultConfig, {
    listing: {
      caption: true,
      title: true,
      type: true,
    },
    sidebar: { enabled: false },
  }),
}
